<script>
    import Icon from '../components/Icon.svelte';
    import { IDLE, INCALL, OUTCALL, OUTGOING } from 'common/callState';
    import { formatDuration } from 'services/utils';
    import { createEventDispatcher } from 'svelte';
    import Modal from 'screens/Modal.svelte';
    import TakeNote from 'screens/TakeNote.svelte';
    import { onMount } from 'svelte';
    import widgetStore from 'store/widget';
    import pubsub from 'sweet-pubsub';
    import { useNavigate } from 'svelte-navigator';
    import callStore from 'store/call';
  import ButtonRounded from '../common/ButtonRounded.svelte';

    let microphone = false;
    let pause = false;
    const navigate = useNavigate()

    const dispatch = createEventDispatcher();

    let notes = '';

    const toggleMute = () => {
        microphone = !microphone;

        if (microphone) {
            dispatch('unMute');
        } else {
            dispatch('mute');
        }
    };
    
    const toggleHold = () => {
        pause = !pause;

        if (pause) {
            dispatch('hold');
        } else {
            dispatch('unHold');
        }
    };

    const hangup = () => {
        if ($callStore.state !== IDLE) {
            dispatch('hangup');
        }

        if ($callStore.state === IDLE || $callStore.state == OUTGOING || $callStore.notes.length === 0) {
            callStore.update({
                call_active: false
            })
            
            navigate("/rate", {
                replace: true,
            });
        }
    };

    onMount(async () => {
        pubsub.on('terminate_call', () => {
            hangup()
        })
    });
</script>

<div class="flex h-full w-full">
    <section class="flex flex-col w-full h-full justify-center items-center">
        <Modal open={$callStore.take_note} close_on_escape={true} close_on_background_click={true}>
            <TakeNote
                bind:notes
                on:hangup={() => {
                    hangup();
                    callStore.update({
                        take_note: false
                    })
                }}
                on:mute={toggleMute}
            />
        </Modal>
        <div class="avatar-logo w-20 h-20 rounded-full flex justify-center items-center mt-10">
            <Icon icon="call-avatar" size="30" />
        </div>
        <div class="text-blue-900 text-lg text-center mb-1 mt-4">{ $widgetStore.business_name || '' }</div>
        <div class="text-green-600 text-sm text-center mb-4">{formatDuration($callStore.duration)}</div>
        <div class="gap-8 flex items-center justify-center">
            <div class="call-action">
                <ButtonRounded
                    disabled={$callStore.state !== INCALL && $callStore.state !== OUTCALL}
                    on:click={toggleHold}
                    size="12"
                    title=""
                    icon="pause"
                    iconColor={pause ? '#EF3333' : '#474B50'}
                    iconSize=24
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">{pause ? 'Un-Hold' : 'Hold'}</span>
            </div>
            <div class="call-action">
                <ButtonRounded
                    disabled={$callStore.state !== INCALL && $callStore.state !== OUTCALL}
                    on:click={toggleMute}
                    size="12"
                    title=""
                    icon={microphone ? 'microphone-mute' : 'microphone'}
                    iconColor={microphone ? '#EF3333' : '#474B50'}
                    iconSize=24
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Mute</span>
            </div>
            <div class="call-action">
                <ButtonRounded
                    disabled={$callStore.state !== INCALL && $callStore.state !== OUTCALL}
                    on:click={hangup}
                    size="12"
                    title=""
                    icon="end-call"
                    iconColor="#fff"
                    iconSize=24
                    className="bg-red-600 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">End</span>
            </div>
        </div>
    </section>
</div>

<style lang="scss">
    .avatar-logo {
        background-color: #fff;
        position: relative;
        width: 5rem;
        height: 5rem;

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            border-radius: 50px;
            padding: 7px; /* control the border thickness */
            background: linear-gradient(45deg, color-mix(in srgb, var(--primary-bg-color) 50%, white), var(--primary-bg-color));
            -webkit-mask: 
                linear-gradient(#fff 0 0) content-box, 
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
                    mask-composite: exclude;
            pointer-events: none;
        }
    }
</style>
<!-- -->